import React from 'react';

import { ReactFCV } from '@types';

import {
  StyledImageSkeleton,
  StyledInfoSkeleton,
  StyledInfoWrapper,
  StyledProductContainer,
  StyledSumWrapper,
  StyledTitleSkeleton,
} from './styled';

export const Product: ReactFCV = () => (
  <StyledProductContainer>
    <StyledImageSkeleton width={4.375} />
    <StyledInfoWrapper>
      <StyledTitleSkeleton width={8} />
      <StyledInfoSkeleton width={10} />
      <StyledSumWrapper>
        <StyledInfoSkeleton width={1.5} />
        <StyledInfoSkeleton width={3} />
      </StyledSumWrapper>
    </StyledInfoWrapper>
  </StyledProductContainer>
);
